(function () {
  'use strict';

  var timers = [];
  var businessDays = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'];
  var defaultTimeZone = 'America/Santiago';
  // Ventana visible de la barra, en horas antes del corte. Medir desde
  // medianoche dejaba la barra bajo 20% (rojo) desde las 09:40 todos los días:
  // una alarma permanente no informa nada. Con 3h la barra recién arranca al
  // abrir la mañana y se agota de verdad hacia el corte.
  var defaultWindowHours = 3;
  // Tiene que calzar con el intervalo de start(): la barra anticipa el
  // próximo tick y se desliza hacia él en vez de saltar y quedarse quieta.
  var tickIntervalSeconds = 15;
  var dayNames = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
  var monthNames = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];

  // Un Intl.DateTimeFormat por zona horaria, no uno por tick. Antes se
  // construían ocho por segundo y por instancia: ~0,3 ms en escritorio, varias
  // veces eso en un móvil de gama media, para siempre mientras la pestaña
  // estuviera abierta.
  var formatterCache = {};

  function getFormatter(timeZone) {
    if (!formatterCache[timeZone]) {
      formatterCache[timeZone] = new Intl.DateTimeFormat('en-US', {
        timeZone: timeZone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        weekday: 'short',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hourCycle: 'h23'
      });
    }

    return formatterCache[timeZone];
  }

  function partsOf(date, timeZone) {
    var parts = getFormatter(timeZone).formatToParts(date);
    var values = {};

    parts.forEach(function (part) {
      values[part.type] = part.value;
    });

    return values;
  }

  function getLocalTime(timeZone) {
    var values = partsOf(new Date(), timeZone);

    return {
      year: parseInt(values.year, 10),
      month: parseInt(values.month, 10),
      day: parseInt(values.day, 10),
      weekday: values.weekday,
      seconds: (parseInt(values.hour, 10) * 3600) + (parseInt(values.minute, 10) * 60) + parseInt(values.second, 10)
    };
  }

  function getTimeZoneOffsetMs(date, timeZone) {
    var values = partsOf(date, timeZone);

    return Date.UTC(
      parseInt(values.year, 10),
      parseInt(values.month, 10) - 1,
      parseInt(values.day, 10),
      parseInt(values.hour, 10),
      parseInt(values.minute, 10),
      parseInt(values.second, 10)
    ) - date.getTime();
  }

  function getZonedTimestamp(localDate, hour, minute, timeZone) {
    var utcGuess = Date.UTC(localDate.year, localDate.month - 1, localDate.day, hour, minute, 0);

    // Recalculate the offset so el corte significa esa hora en Santiago, incluso al cambiar el horario de verano.
    for (var attempt = 0; attempt < 3; attempt += 1) {
      utcGuess = Date.UTC(localDate.year, localDate.month - 1, localDate.day, hour, minute, 0) - getTimeZoneOffsetMs(new Date(utcGuess), timeZone);
    }

    return utcGuess;
  }

  function isoOf(localDate) {
    return String(localDate.year) + '-' +
      String(localDate.month).padStart(2, '0') + '-' +
      String(localDate.day).padStart(2, '0');
  }

  // Feriados chilenos: sin esto el 18 de septiembre el bloque promete despacho
  // igual. Vienen del setting como lista de fechas YYYY-MM-DD; el merchant las
  // carga una vez al año.
  function isShippingDay(localDate, weekday, holidays) {
    if (weekday && businessDays.indexOf(weekday) === -1) return false;
    if (!weekday) {
      var probe = new Date(Date.UTC(localDate.year, localDate.month - 1, localDate.day));
      if (probe.getUTCDay() === 0 || probe.getUTCDay() === 6) return false;
    }

    return holidays.indexOf(isoOf(localDate)) === -1;
  }

  function shiftToShippingDate(localDate, step, holidays) {
    var date = new Date(Date.UTC(localDate.year, localDate.month - 1, localDate.day));
    var candidate;
    // Tope de 30 días: si alguien pega un año entero de feriados en el setting,
    // el bucle termina igual en vez de colgar la pestaña.
    var guard = 0;

    do {
      date.setUTCDate(date.getUTCDate() + step);
      candidate = {
        year: date.getUTCFullYear(),
        month: date.getUTCMonth() + 1,
        day: date.getUTCDate()
      };
      guard += 1;
    } while (guard < 30 && !isShippingDay(candidate, null, holidays));

    return candidate;
  }

  function parseHolidays(raw) {
    if (!raw) return [];

    return raw.split(/[,\s]+/).filter(function (value) {
      return /^\d{4}-\d{2}-\d{2}$/.test(value);
    });
  }

  // Previsualización de estados, sólo en temas NO publicados. El bloque cambia
  // de cara tres veces al día y sólo de lunes a viernes antes del corte, así
  // que revisarlo a ojo obligaba a esperar a la hora correcta o a editar el
  // setting y volver a publicarlo. Con ?cutoff=HH:MM se ve cualquier estado
  // cuando sea.
  //
  // El guardia es Shopify.theme.role: en el tema principal la función devuelve
  // null y el parámetro no hace absolutamente nada, así que ningún visitante
  // puede hacer que la tienda le prometa una hora de corte que no existe.
  function previewCutoff() {
    if (typeof window === 'undefined') return null;

    var theme = window.Shopify && window.Shopify.theme;
    if (!theme || theme.role === 'main') return null;

    var raw = new URLSearchParams(window.location.search).get('cutoff');
    var match = raw && raw.match(/^(\d{1,2}):(\d{2})$/);
    if (!match) return null;

    var hour = parseInt(match[1], 10);
    var minute = parseInt(match[2], 10);
    if (hour > 23 || minute > 59) return null;

    return { hour: hour, minute: minute };
  }

  function readConfig(element) {
    var hour = parseInt(element.dataset.cutoffHour, 10);
    var minute = parseInt(element.dataset.cutoffMinute, 10);
    var preview = previewCutoff();

    if (preview) {
      hour = preview.hour;
      minute = preview.minute;
    }

    return {
      timeZone: element.dataset.timeZone || defaultTimeZone,
      hour: isNaN(hour) ? 12 : hour,
      minute: isNaN(minute) ? 0 : minute,
      windowHours: parseFloat(element.dataset.windowHours) || defaultWindowHours,
      holidays: parseHolidays(element.dataset.holidays)
    };
  }

  function getState(config) {
    var now = getLocalTime(config.timeZone);
    var cutoffSeconds = (config.hour * 3600) + (config.minute * 60);
    var shipsToday = isShippingDay(now, now.weekday, config.holidays);
    var isBeforeCutoff = shipsToday && now.seconds < cutoffSeconds;
    var windowSeconds = config.windowHours * 60 * 60;
    var cutoffToday = getZonedTimestamp(now, config.hour, config.minute, config.timeZone);
    var nextCutoffDate;

    if (isBeforeCutoff) {
      nextCutoffDate = now;
    } else {
      nextCutoffDate = shiftToShippingDate(now, 1, config.holidays);
    }

    var nextCutoff = isBeforeCutoff
      ? cutoffToday
      : getZonedTimestamp(nextCutoffDate, config.hour, config.minute, config.timeZone);
    var remaining = Math.max(0, (nextCutoff - Date.now()) / 1000);
    // Día en que despacharía si se pierde el corte de HOY, sin importar si ya
    // estamos antes o después: es el contraste de pérdida, no la promesa.
    var missDate = shiftToShippingDate(now, 1, config.holidays);

    return {
      // La barra mide la ventana declarada en el setting, no el ciclo de 24h.
      // Antes `window_hours` no controlaba nada: la barra salía roja a las
      // 09:00 con tres horas por delante mientras el panel decía "abierto".
      progress: progressFor(remaining, windowSeconds),
      urgency: urgencyOf(remaining, windowSeconds),
      name: isBeforeCutoff ? urgencyOf(remaining, windowSeconds) : 'next-day',
      seconds: remaining,
      afterCutoff: !isBeforeCutoff,
      closedToday: !shipsToday,
      nextCutoffDate: nextCutoffDate,
      nextCutoffAt: nextCutoff,
      todayIso: isoOf(now),
      weekday: now.weekday,
      missDate: missDate
    };
  }

  function progressFor(remainingSeconds, windowSeconds) {
    return Math.max(0, Math.min(100, (remainingSeconds / windowSeconds) * 100));
  }

  // Umbrales por tiempo REAL restante, no por porcentaje de barra: "queda una
  // hora" significa lo mismo sin importar la escala que esté usando la barra.
  function urgencyOf(remainingSeconds, windowSeconds) {
    if (remainingSeconds <= windowSeconds / 3) return 'critical';
    if (remainingSeconds <= windowSeconds) return 'warning';
    return 'open';
  }

  // Horas y minutos, sin segundero. En un ticket de $800.000 el reloj corriendo
  // lee como técnica de venta, no como servicio: el comprador de módulos
  // investiga durante semanas y un cronómetro lo empuja a desconfiar. La
  // información útil ("te quedan dos horas") sobrevive intacta.
  function formatTime(totalSeconds) {
    var seconds = Math.max(0, Math.floor(totalSeconds));
    var hours = Math.floor(seconds / 3600);
    var minutes = Math.floor((seconds % 3600) / 60);

    if (hours && minutes) return hours + 'h ' + String(minutes).padStart(2, '0') + 'm';
    if (hours) return hours + 'h';
    if (minutes) return minutes + 'm';

    return 'menos de 1m';
  }

  // Para lectores de pantalla: en palabras se entiende y evita que el lector
  // reanuncie el bloque a cada rato.
  function formatTimeSpoken(totalSeconds) {
    var seconds = Math.max(0, Math.floor(totalSeconds));
    var hours = Math.floor(seconds / 3600);
    var minutes = Math.floor((seconds % 3600) / 60);
    var partes = [];

    if (hours) partes.push(hours + (hours === 1 ? ' hora' : ' horas'));
    if (minutes) partes.push(minutes + (minutes === 1 ? ' minuto' : ' minutos'));
    if (!partes.length) partes.push('menos de un minuto');

    return partes.join(' y ');
  }

  function formatCutoff(config) {
    return String(config.hour).padStart(2, '0') + ':' + String(config.minute).padStart(2, '0');
  }

  // "Llega hoy" es una promesa; "Llega hoy, jueves 31" es un compromiso. La
  // fecha es lo que el bloque nunca decía y es lo que el comprador traduce
  // mentalmente igual, pero mal.
  function formatDate(localDate) {
    var date = new Date(Date.UTC(localDate.year, localDate.month - 1, localDate.day));

    return dayNames[date.getUTCDay()] + ' ' + localDate.day + ' de ' + monthNames[localDate.month - 1];
  }

  function formatShortDate(localDate) {
    var date = new Date(Date.UTC(localDate.year, localDate.month - 1, localDate.day));

    return dayNames[date.getUTCDay()].slice(0, 3) + ' ' + localDate.day;
  }

  function fill(template, tokens) {
    return Object.keys(tokens).reduce(function (text, key) {
      return text.replace(new RegExp('\\{' + key + '\\}', 'g'), tokens[key]);
    }, template || '');
  }

  function setText(node, value) {
    if (node && node.textContent !== value) node.textContent = value;
  }

  function tokensFor(state, config) {
    return {
      cutoff: formatCutoff(config),
      remaining: formatTime(state.seconds),
      // "mañana" / "el lunes" se calcula contra el calendario real, no contra
      // el día de la semana: un jueves antes de un viernes feriado despacha el
      // lunes, y decir "mañana" ahí es mentir.
      next_day: state.afterCutoff ? nextDayLabel(state) : 'hoy',
      // Versión corta para la píldora del precio: "el lunes 17" en vez de
      // "el lunes 17 de agosto". El mes no desempata nada —el corte siguiente
      // nunca queda a más de unos días— y en móvil esa palabra de más es la
      // que empuja la píldora a una tercera línea.
      next_day_short: state.afterCutoff ? nextDayLabelShort(state) : 'hoy',
      date: state.afterCutoff ? formatDate(state.nextCutoffDate) : 'hoy',
      short_date: formatShortDate(state.nextCutoffDate),
      // El día en que despacharía si el corte de hoy se pierde. Sólo se
      // muestra cuando queda poco tiempo (ver updateBlock); acá se calcula
      // siempre porque tokensFor no sabe de urgencia.
      miss_day: dayLabelFor(state, state.missDate)
    };
  }

  function nextDayLabelShort(state) {
    var label = nextDayLabel(state);
    return label.replace(/ de [a-zé]+$/i, '');
  }

  // Un solo cálculo de "qué día es esto en palabras", para el corte que ya
  // pasó (nextCutoffDate) y para el que se perdería si no se actúa a tiempo
  // (missDate). Es la misma pregunta —¿cuántos días de acá a esa fecha?—
  // hecha sobre dos fechas distintas.
  function dayLabelFor(state, targetDate) {
    var today = new Date(state.todayIso + 'T00:00:00Z');
    var target = Date.UTC(targetDate.year, targetDate.month - 1, targetDate.day);
    var days = Math.round((target - today.getTime()) / 86400000);

    if (days === 1) return 'mañana';

    return 'el ' + formatDate(targetDate);
  }

  function nextDayLabel(state) {
    return dayLabelFor(state, state.nextCutoffDate);
  }

  function updateBlock(element, state, tokens, config) {
    var timer = element.querySelector('[data-cutoff-timer]');
    var miss = element.querySelector('[data-cutoff-miss]');
    var label = element.querySelector('[data-cutoff-label]');
    var progressBar = element.querySelector('[data-cutoff-progressbar]');
    var progress = element.querySelector('[data-cutoff-progress]');
    var axis = element.querySelector('[data-cutoff-axis]');
    var axisEnd = element.querySelector('[data-cutoff-axis-end]');
    var intro = element.querySelector('[data-cutoff-intro]');
    var status = element.querySelector('[data-cutoff-status]');
    var santiago = element.querySelector('[data-route-santiago]');
    var regions = element.querySelector('[data-route-regions]');
    var previousState = element.dataset.state;

    element.dataset.state = state.name;
    // Nivel de urgencia separado del estado: el panel pasado el corte mantiene
    // su mensaje mientras el semáforo sigue avanzando.
    element.dataset.urgency = state.urgency;

    // Un viernes a las 18:00 el contador marcaba "65h 56m": un número que nadie
    // traduce a nada. Pasadas las 24 horas, la fecha del próximo corte es la
    // información, y el conteo es ruido. Bajo 24h vuelve el contador.
    var longWait = state.seconds >= 86400;

    if (timer) {
      timer.hidden = false;
      setText(timer, longWait ? tokens.short_date + ' · ' + tokens.cutoff : formatTime(state.seconds));
      timer.setAttribute('datetime', 'PT' + Math.max(0, Math.floor(state.seconds)) + 'S');
      timer.classList.toggle('iw-delivery-cutoff__timer--date', longWait);
    }

    // El contraste de pérdida: sólo en warning/critical y antes del corte.
    // Con horas de sobra por delante ("open") esto es ruido — el mensaje
    // tiene que ganarse el espacio con urgencia real, no repetirse siempre.
    if (miss) {
      var showMiss = !state.afterCutoff && (state.urgency === 'warning' || state.urgency === 'critical');
      miss.hidden = !showMiss;
      if (showMiss) setText(miss, 'Después de las ' + tokens.cutoff + ', el siguiente despacho es ' + tokens.miss_day + '.');
    }

    if (progressBar && progress) {
      progressBar.hidden = false;
      // El gas del tubo mide siempre el largo completo y se corre a la
      // izquierda: a 40% restante queda en translateX(-60%). Animar `width`
      // obligaba a layout + paint en cada tick, y translateX no toca el layout.
      //
      // El tick corre cada 15s pero el tubo no puede quedarse quieto 15s y
      // saltar: no informa como gas escapando, informa como reloj trabado.
      // Por eso no apunta al valor de AHORA sino al que va a tener en el
      // próximo tick, y desliza con CSS por esa misma duración — el JS sigue
      // corriendo cada 15s, el movimiento se ve continuo igual.
      var isFirstRender = !previousState;
      var windowSeconds = config.windowHours * 3600;
      var displaySeconds = isFirstRender ? state.seconds : Math.max(0, state.seconds - tickIntervalSeconds);
      var displayProgress = state.afterCutoff ? state.progress : progressFor(displaySeconds, windowSeconds);
      progress.style.setProperty('--cutoff-tick', isFirstRender ? '0s' : tickIntervalSeconds + 's');
      var fillTransform = 'translateX(' + (Math.max(0, Math.min(100, displayProgress)) - 100).toFixed(1) + '%)';
      // Escribir sólo cuando cambia: antes se pisaba el estilo cada segundo y
      // se forzaba recálculo aunque el valor fuera idéntico.
      if (progress.style.transform !== fillTransform) progress.style.transform = fillTransform;
      progressBar.setAttribute('aria-valuenow', String(Math.round(state.progress)));
      // Anunciar el tiempo real, no el % de la barra: con la ventana topada en
      // 100%, "100% restante" mentía cuando aún faltaban 11 horas.
      progressBar.setAttribute('aria-valuetext', state.afterCutoff
        ? 'Corte cerrado. Próximo corte ' + tokens.date + ' a las ' + tokens.cutoff
        : 'Quedan ' + formatTimeSpoken(state.seconds) + ' para el corte de las ' + tokens.cutoff);
    }

    // El eje se rotula con el corte vigente, no con un "12:00 · corte de hoy"
    // fijo en el HTML que seguía diciendo "hoy" un sábado, justo encima de un
    // contador que apuntaba al lunes.
    if (axis) {
      axis.hidden = false;
      setText(axisEnd, state.afterCutoff
        ? tokens.short_date + ' · ' + tokens.cutoff
        : tokens.cutoff + ' · corte de hoy');
    }

    if (label) {
      var labelText = state.afterCutoff ? label.dataset.afterLabel : label.dataset.beforeLabel;
      // "Próximo corte en lun 3 · 12:00" no se lee; sin el "en", sí.
      if (longWait) labelText = labelText.replace(/\s+en$/i, '');
      setText(label, labelText);
    }

    if (santiago) {
      setText(santiago, fill(state.afterCutoff ? santiago.dataset.afterDetail : santiago.dataset.beforeDetail, tokens));
    }
    if (regions) {
      setText(regions, fill(state.afterCutoff ? regions.dataset.afterDetail : regions.dataset.beforeDetail, tokens));
    }

    if (intro) {
      var template = intro.dataset.beforeTemplate;
      if (state.closedToday) template = intro.dataset.weekendTemplate || intro.dataset.afterTemplate;
      else if (state.afterCutoff) template = intro.dataset.afterTemplate;
      setText(intro, fill(template, tokens));
    }

    if (status && previousState !== state.name) {
      status.textContent = state.afterCutoff
        ? fill(intro ? intro.dataset.afterTemplate : '', tokens)
        : (label ? label.textContent + ' ' : '') + formatTimeSpoken(state.seconds) + '. ' + fill(intro ? intro.dataset.beforeTemplate : '', tokens);
    }
  }

  function updateLine(element, state, tokens) {
    var promise = element.querySelector('[data-line-promise]');
    var link = element.querySelector('[data-line-link]');

    element.dataset.state = state.name;
    element.dataset.urgency = state.urgency;

    if (promise) {
      var template = promise.dataset.beforeTemplate;
      if (state.closedToday) template = promise.dataset.weekendTemplate || promise.dataset.afterTemplate;
      else if (state.afterCutoff) template = promise.dataset.afterTemplate;
      setText(promise, fill(template, tokens));
    }

    // El ancla sólo sirve si el detalle está en la página: si el merchant sacó
    // el bloque completo, el link se esconde en vez de saltar al vacío.
    if (link && !document.getElementById(element.dataset.detailId)) {
      link.hidden = true;
    }
  }

  // El detalle vive cerrado. Saltar al ancla sin abrirlo dejaba al comprador
  // mirando el mismo rótulo que acababa de tocar, así que el link lo abre y
  // recién ahí hace scroll — un solo gesto, no dos.
  function bindDetailLink(element) {
    var link = element.querySelector('[data-line-link]');
    if (!link || link.dataset.bound) return;

    link.dataset.bound = 'true';
    link.addEventListener('click', function (event) {
      var detail = document.getElementById(element.dataset.detailId);
      if (!detail || detail.tagName !== 'DETAILS') return;

      event.preventDefault();
      detail.open = true;
      detail.scrollIntoView({ block: 'center', behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
      // El foco va al resumen y no al panel: es el control real, así que desde
      // ahí se puede cerrar con Enter sin salir a buscar nada.
      var summary = detail.querySelector('summary');
      if (summary) summary.focus({ preventScroll: true });
    });
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function update(element) {
    if (element.hasAttribute('data-preorder')) return;

    var config = readConfig(element);
    var state = getState(config);
    var tokens = tokensFor(state, config);

    if (element.hasAttribute('data-delivery-line')) {
      updateLine(element, state, tokens);
      bindDetailLink(element);
    } else {
      updateBlock(element, state, tokens, config);
    }
  }

  function elements() {
    return document.querySelectorAll('[data-delivery-cutoff], [data-delivery-line]');
  }

  function stop() {
    timers.forEach(function (timer) { clearInterval(timer); });
    timers = [];
  }

  function start() {
    stop();
    elements().forEach(function (element) {
      update(element);
      // Sin segundero, un tick cada 15s basta para que el minuto no se atrase
      // de forma perceptible, y baja el trabajo en segundo plano a 1/15.
      timers.push(setInterval(function () { update(element); }, tickIntervalSeconds * 1000));
    });
  }

  // Pestaña oculta: nada que mostrar, nada que calcular. Al volver se actualiza
  // de inmediato, así que no se ve un valor viejo ni por un frame.
  function handleVisibility() {
    if (document.hidden) stop();
    else start();
  }

  function init() {
    if (document.hidden) {
      stop();
      elements().forEach(update);
      return;
    }

    start();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('visibilitychange', handleVisibility);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', init);
  // IW Nuevo: assets/iw-buy-box.js swaps the delivery markup when the shopper picks another variant and asks for a re-read.
  document.addEventListener('iw:delivery-refresh', init);
})();
